/**
 * Centralized maintenance-mode copy for the app.
 *
 * Single source of truth for banner text, toasts, and any other
 * user-facing maintenance messaging.
 */
export const MAINTENANCE = {
  /** Banner at top of app when maintenance mode is on */
  BANNER: {
    title: 'Maintenance in progress',
    description: 'Some features are temporarily unavailable. Please try again shortly.',
  },
  /** Toast when user tries to submit an inquiry during maintenance */
  INQUIRY_TOAST: {
    title: 'Maintenance in progress',
    message: 'Inquiry submissions are temporarily unavailable. Please try again shortly.',
  },
  /** Toast when user tries to send a message during maintenance */
  MESSAGES_TOAST: {
    title: 'Maintenance in progress',
    message: 'Messages cannot be sent right now. Please try again shortly.',
  },
} as const;
